import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_item
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackViewItemItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackViewItemParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackViewItemItem> {}

const trackViewItem = (parameters: TrackViewItemParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "view_item", ...parameters }, { ...options, skipItemIndex: true });
};

export default trackViewItem;
